<template>
  <v-container>
    <h1 class="text-center text-uppercase">Order Items</h1>
    <template v-if="ONLINE_ORDERS_ITEMS.order != undefined">
      <template v-if="ONLINE_ORDERS_ITEMS.items.length>=1">
        <v-row class="text-center">
          <v-col class="text-left">
            <p class="caption">ORDER ID{{ " #"+ONLINE_ORDERS_ITEMS.order.id}}</p>
            <p class="caption">Name : {{ ONLINE_ORDERS_ITEMS.order.name}}</p>
          </v-col>
          <v-col class="text-left">
            <p class="caption">Phone : {{ ONLINE_ORDERS_ITEMS.order.phone}}</p>
            <p class="caption">Email : {{ ONLINE_ORDERS_ITEMS.order.email}}</p>
          </v-col>
          <v-col class="text-left">
            <p class="caption">Address : {{ ONLINE_ORDERS_ITEMS.order.address}}</p>
          </v-col>
        </v-row>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">ITEM</th>
                <th class="text-left">Item Qty</th>
                <th class="text-left">Rate</th>
                <th class="text-left">Item Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in ONLINE_ORDERS_ITEMS.items" :key="item.id">
                <td>{{ item.name }}</td>
                <td>{{ item.qty}}</td>
                <td>{{ item.rate | rupee}}</td>
                <td>{{ item.itemtotal | rupee}}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <div
          class="text-right overline"
        >Grand Total {{ ONLINE_ORDERS_ITEMS.order.grandtotal | rupee}}</div>
      </template>
      <template v-else>
        <v-alert type="info" class="text-center">No Orders Yet</v-alert>
      </template>
    </template>
    <template v-else>
      <v-alert type="info" class="text-center">No Orders Found</v-alert>
    </template>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  computed: {
    ...mapGetters(["ONLINE_ORDERS_ITEMS"]),
  },
  created() {
    this.$store.commit("SET_LOADING", true);
    this.GET_ONLINE_ORDERS_ITEMS(this.$route.params.id).then(() => {
      this.$store.commit("SET_LOADING", false);
    });
  },
  methods: {
    ...mapActions(["GET_ONLINE_ORDERS_ITEMS"]),
  },
};
</script>

<style>
</style>